<app-card>
  <div class="-mx-6 -my-8">
    <app-map #map class="w-full block aspect-video"></app-map>
  </div>
</app-card>
